import axios, { AxiosInstance } from 'axios';
import { attachAuthInterceptors } from './interceptors';

export type CreateHttpClientOptions = {
  /** Per-request timeout in ms. Omit for axios default (no limit — can hang on dead hosts). */
  timeoutMs?: number;
};

export const createHttpClient = (baseURL?: string, opts?: CreateHttpClientOptions): AxiosInstance => {
  const defaultBaseURL = import.meta.env.VITE_GATEWAY_URL || 'http://localhost:8080';

  const client = axios.create({
    baseURL: baseURL || defaultBaseURL,
    ...(opts?.timeoutMs != null ? { timeout: opts.timeoutMs } : {}),
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });

  attachAuthInterceptors(client);

  return client;
};

